import { render, staticRenderFns } from "./CustomFormBaseElement.vue?vue&type=template&id=51610b64"
import script from "./CustomFormBaseElement.vue?vue&type=script&lang=js"
export * from "./CustomFormBaseElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports